/**
 * 切换到背景角色
 * @param tips
 */
import clickElement from "./click-element";
import {BATCH_TIPS_MODE} from '../../lib/constant';

export default function switchToBg({tips}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    if (!tips) {
        tips = '点击这里切换到背景';
    }
    if (mode) {
        window.stepsRuntime.insertTips(_index, tips, true);
        if (mode === BATCH_TIPS_MODE) {
            return new Promise(resolve => {
                resolve();
            })
        }
    }
    return clickElement({
        element: '[class^="target-pane_stage-selector-wrapper"]',
        tips
    }).then(()=>{
        showMessage("正在切换到背景，请等待1秒钟再继续操作");
        return new Promise(resolve => {
            setTimeout(resolve, 1000);
        })
    });
}
